import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { BasePage } from './../../pages/base.page';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ProductColorModel } from 'src/app/models/wardrobe.model';
import { WardrobeService } from './../../services/wardrobe.service';
import { MediaCaptureProvider } from 'src/app/services/media-capture';
import { ErrorHandlerService } from './../../services/error-handler.service';
import { ProductCategoryModalComponent } from '../product-category-modal/product-category-modal.component';
import {
  ActionSheetController,
  LoadingController,
  ModalController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { ImageZoomComponent } from '../image-zoom/image-zoom.component';

@Component({
  selector: 'shc-edit-image-modal',
  templateUrl: './edit-image-modal.component.html',
  styleUrls: ['./edit-image-modal.component.scss'],
})
export class EditImageModalComponent extends BasePage implements OnInit {
  @Input() image: string;
  convertedImage: string;
  backgroundImage: string;
  selectedColor: ProductColorModel;
  imageType: string;

  form: UntypedFormGroup;
  // ngAfterViewInit() {
  //   mediumZoom('[data-zoomable]', {
  //     margin: 24,
  //     background: '#000'
  //   });
  // }
  constructor(
    protected platform: Platform,
    camera: Camera,
    actionSheetCtrl: ActionSheetController,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    mediaCapture: MediaCaptureProvider,
    toastController: ToastController,
    private modalCtrl: ModalController,
    private wardrobeService: WardrobeService,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
      mediaCapture,
      actionSheetCtrl,
      camera,
    );
  }

  ngOnInit() {
    this.imageType = this.image.split(';')[0].split('/')[1];

    this.form = new UntypedFormGroup({
      type: new UntypedFormControl('original'),
      bg_image_file: new UntypedFormControl(null),
      bg_color_code: new UntypedFormControl(null),
    });
  }

  async selectColor(value: string) {
    const modal = await this.modalCtrl.create({
      component: ProductCategoryModalComponent,
      componentProps: {
        value,
      },
      cssClass: 'product-category-modal-create',
      id: 'productCategory',
      keyboardClose: true,
      backdropDismiss: true,
      canDismiss: true,
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        this.selectedColor = data.data;
      }
      // this.modalCtrl.dismiss();
    });

    return await modal.present();
  }
 async handleImgClick(imageUrl: string) {
    const modal = await this.modalCtrl.create({
      component: ImageZoomComponent,
      cssClass: 'custom-zoom-modal',
      canDismiss: true,
      id: 'custom-zoom-modal',
      componentProps: {
        imageUrl: imageUrl,
      },
    });
    // modal.onDidDismiss().then((data) => {
    //   this.modalCtrl.dismiss();
    // });
    return await modal.present();
  }
  async cordovaPictureChange(event: Event, maxImages: number) {
    if (
      (window as any).cordova &&
      (window as any).cordova.platformId !== 'browser'
    ) {
      console.log('test');
      event.stopPropagation();
      if (this.selectedImages && this.selectedImages.length >= maxImages) {
        this.showToast(
          this.translate.instant(marker('ValidationMessage.MaxUploadLimit')),
        );
        return;
      } else {
        const alert = await this.actionSheetCtrl.create({
          header: this.translate.instant(marker('Camera.Select')),
          backdropDismiss: true,
          cssClass: 'removeCancelButton',
          buttons: [
            {
              icon: 'close',
              text: this.translate.instant(marker('Buttons.Cancel')),
              role: 'cancel',
            },
            {
              icon: 'camera',
              text: this.translate.instant(marker('Camera.Source.Camera')),
              handler: () => {
                this.mediaCapture
                  .getPicture(
                    this.camera.PictureSourceType.CAMERA,
                    true,
                    this.camera.MediaType.PICTURE,
                  )
                  .then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          console.log(result.file, 'camera results');
                          this.backgroundImage = result.file;
                        } else {
                          this.showToast(
                            this.translate.instant(
                              marker('ValidationMessage.ValidImage'),
                            ),
                          );
                        }
                      }
                      this.hideLoader();
                    },
                    (error) => {
                      this.hideLoader();
                      if (error) {
                        this.showToast(
                          this.translate.instant(
                            marker('ValidationMessage.PermissionDenied'),
                          ),
                        );
                      } else {
                        this.showToast(
                          this.translate.instant(
                            marker('ValidationMessage.NoFileSelected'),
                          ),
                        );
                      }
                    },
                  );
              },
            },
            {
              icon: 'images-outline',
              text: this.translate.instant(
                marker('Camera.Source.PhotoLibrary'),
              ),
              handler: () => {
                this.mediaCapture
                  .getPicture(
                    this.camera.PictureSourceType.PHOTOLIBRARY,
                    true,
                    this.camera.MediaType.PICTURE,
                  )
                  .then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          console.log(result.file, 'camera results');
                          this.backgroundImage = result.file;
                        } else {
                          this.showToast(
                            this.translate.instant(
                              marker('ValidationMessage.ImageOnly'),
                            ),
                          );
                        }
                      }
                      this.hideLoader();
                    },
                    (error) => {
                      this.hideLoader();
                      if (error) {
                        this.showToast(
                          this.translate.instant(
                            marker('ValidationMessage.PermissionDenied'),
                          ),
                        );
                      } else {
                        this.showToast(
                          this.translate.instant(
                            marker('ValidationMessage.NoFileSelected'),
                          ),
                        );
                      }
                    },
                  );
              },
            },
          ],
        });
        await alert.present();
      }
    } else {
      event.stopPropagation();
    }
  }


  // async cordovaPictureChange(event: Event, maxImages: number) {
  //   if (
  //     (window as any).cordova &&
  //     (window as any).cordova.platformId !== 'browser'
  //   ) {
  //     console.log('test');
  //     event.stopPropagation();
  //     const alert = await this.actionSheetCtrl.create({
  //       header: this.translate.instant(marker('Camera.Select')),
  //       backdropDismiss: true,
  //       cssClass: 'removeCancelButton',
  //       buttons: [
  //         {
  //           icon: 'close',
  //           text: this.translate.instant(marker('Buttons.Cancel')),
  //           role: 'cancel',
  //         },
  //         {
  //           icon: 'camera',
  //           text: this.translate.instant(marker('Camera.Source.Camera')),
  //           handler: () => 
  //             this.pickImageFrom(this.camera.PictureSourceType.CAMERA),
            
  //         },
  //         {
  //           icon: 'images-outline',
  //           text: this.translate.instant(
  //             marker('Camera.Source.PhotoLibrary')
  //           ),
  //           handler: () => 
  //             this.pickImageFrom(this.camera.PictureSourceType.PHOTOLIBRARY),
  //         },
  //       ],
  //     });
  //     await alert.present();
  //   } else {
  //     event.stopPropagation();
  //   }
  // }

  private async pickImageFrom(sourceType: number) {
    try {
      this.showLoader();
      const result = await this.mediaCapture.getPicture(sourceType, true, this.camera.MediaType.PICTURE);
      if (result && result.includes('data:image/')) {
        this.backgroundImage = result;
      } else {
        this.showToast(this.translate.instant(marker('ValidationMessage.ImageOnly')));
      }
    } catch (error) {
      this.showToast(this.translate.instant(
        error ? marker('ValidationMessage.PermissionDenied') : marker('ValidationMessage.NoFileSelected'),
      ));
    } finally {
      this.hideLoader();
    }
  }

  onImageChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const imageFiles = target.files;
    if (imageFiles && imageFiles[0]) {
      this.mediaCapture.readFile(imageFiles[0]).then((base64data) => {
        if (base64data.startsWith('data:image/')) {
          this.backgroundImage = base64data;
          // Reset the input value so the same file can be selected again
          target.value = '';
        }
      });
      
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }
async returnImage() {
  if (this.form.value.type === 'original') {
    // const base64String = this.canvas.toDataURL(`image/${this.imageType}`);
    //   const base64 = await fetch(base64String);
    this.modalCtrl.dismiss(this.image, null, 'editImage');
    return;
  }

  let imgMimeType = 'png';

  // Convert base64 or URL to blob
  const base64 = await fetch(this.image);
  const blob = await base64.blob();

  const formData = new FormData();
  formData.append('image', blob);
  formData.append('format', imgMimeType);

  // if (this.form.value.type === 'bg_color_code') {
  //   this.form.patchValue({
  //     bg_color_code: this.selectedColor?.code,
  //   });
  //   formData.append('bg_color_code', this.selectedColor?.code);
  // } else if (this.form.value.type === 'bg_image_file') {
  //   this.form.patchValue({
  //     bg_image_file: this.backgroundImage,
  //   });
  //   const bgbase64 = await fetch(this.backgroundImage);
  //   const bgblob = await bgbase64.blob();
  //   formData.append('bg_image_file', bgblob);
  // }

  this.showLoader();
  this.wardrobeService
    .removeProductBackground(formData)
    .pipe(
      finalize(() => {
        this.hideLoader();
        if (this.user.slazzer_credits > 0) {
          this.user.slazzer_credits = this.user.slazzer_credits - 1;
        }
      }),
    )
    .subscribe(
      (res: { converted_image: string }) => {
        this.convertedImage =
          'data:image/' + imgMimeType + ';base64,' + res.converted_image;
        this.modalCtrl.dismiss(this.convertedImage, null, 'editImage');
      },
      (error) => {
        this.errorService.handle(error);
        this.modalCtrl.dismiss(this.image, null, 'editImage');
      },
    );
}

// rotateImage() {
//     this.angle = this.angle + 90;
//     // this.ctx_hidden.rotate(this.angle * Math.PI / 180);

//     this.drawRotatedAgain(this.angle);
//   }

//   drawRotated() {
//     this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
//     this.ctx.save();
//     this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2);
//     this.ctx.rotate((this.angle * Math.PI) / 180);
//     this.ctx.drawImage(
//       this.tempImage,
//       -this.canvas.width / 2,
//       -this.canvas.height / 2,
//       this.canvas.height,
//       this.canvas.width,
//     );
//     this.ctx.restore();

//     /**
//      * Hidden Canvas
//      */
//     // this.ctx_hidden.clearRect(0, 0, this.canvas_hidden.width, this.canvas_hidden.height);
//     // this.ctx_hidden.save();
//     // this.ctx_hidden.translate(this.canvas_hidden.width / 2, this.canvas_hidden.height / 2);
//     // this.ctx_hidden.drawImage(this.tempImage, -this.canvas_hidden.width / 2, -this.canvas_hidden.height / 2, this.canvas_hidden.height, this.canvas_hidden.width);
//     // this.ctx_hidden.restore();
//   }

//   drawRotatedAgain(degrees) {
//     // this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
//     this.ctx.fillStyle = 'white';
//     this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
//     this.ctx.save();
//     this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2);
//     this.ctx.rotate((degrees * Math.PI) / 180);

//     var hRatio =
//       this.canvas.width /
//       (degrees % 180 === 0 ? this.tempImage.width : this.tempImage.height);
//     var vRatio =
//       this.canvas.height /
//       (degrees % 180 === 0 ? this.tempImage.height : this.tempImage.width);
//     var ratio = Math.min(hRatio, vRatio);
//     var targetWidth = this.tempImage.width * ratio;
//     var targetHeight = this.tempImage.height * ratio;
//     var centerShift_x = targetWidth / 2;
//     var centerShift_y = targetHeight / 2;

//     this.ctx.drawImage(
//       this.tempImage,
//       0,
//       0,
//       this.tempImage.width,
//       this.tempImage.height,
//       -centerShift_x,
//       -centerShift_y,
//       targetWidth,
//       targetHeight,
//     );

//     this.ctx.restore();
//   }

}
